import * as React from 'react';
import * as Edge from '../../../core';
import ExerciseResultLayout from '../exerciseResultLayout';
import { ExerciseMetadataService } from '../../../services/exerciseMetadataService';

export interface DepthResultsProps {
	results: Edge.Models.DepthExerciseResult;
	completeText: string;
	retry: () => void;
	complete: () => void;
	hideExerciseResults: boolean;
}

export class DepthResults extends React.PureComponent<DepthResultsProps> {
	constructor(props: DepthResultsProps) {
		super(props);
		this.state = {};
	}
	public render() {
		const { complete, completeText, results, retry, hideExerciseResults } = this.props;
		const exercise = ExerciseMetadataService.getMetadata(results);
		return (
			<ExerciseResultLayout
				className="depth_results"
				exerciseName="Depth"
				description={exercise && exercise.description}
				headerActions={
					<>
						<button className="cta_btn" onClick={retry}>
							Retry Exercise
						</button>
						<button className="cta_btn" onClick={complete}>
							{completeText}
						</button>
					</>
				}
				results={[results]}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}

export default DepthResults;
